/**
 * バーコードラベルの「組む → 印刷タブを開く → 画面へ出す報告を返す」までを1本にする。
 *
 * 発注書・発注点（棚札）・入荷の3画面が同じ手順を踏むので、印刷の判断（0枚なら開かない）を
 * 1箇所に置く。呼び出し側は返ってきた報告を `BarcodeLabelResultBanner` へ渡すだけでよい。
 */

import {
  buildBarcodeLabelSheet,
  type BarcodeLabelItem,
  type BarcodeLabelSheetOptions,
  type BarcodeLabelSheetResult,
} from "./barcodeLabels";
import { printHtmlDocument } from "./printHtml";

/** 画面へ報告する部分（HTML 本体は持ち回らない）。 */
export type BarcodeLabelPrintReport = Omit<BarcodeLabelSheetResult, "html">;

export function printBarcodeLabels(
  items: BarcodeLabelItem[],
  options: BarcodeLabelSheetOptions = {},
): BarcodeLabelPrintReport {
  const sheet = buildBarcodeLabelSheet(items, options);
  // 1枚も出ないときは印刷ダイアログを出さない（空のタブが開くだけで用がない）。
  // 出なかった理由は報告として返す＝黙って何も起きないのが最悪の壊れ方。
  if (sheet.labelCount > 0) printHtmlDocument(sheet.html);
  return {
    labelCount: sheet.labelCount,
    skippedNoBarcode: sheet.skippedNoBarcode,
    textOnlyCount: sheet.textOnlyCount,
  };
}
